var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cargo-advance-search fcl-search-bar",
      staticStyle: { height: "auto", width: "100%", "margin-top": "5px" }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showSimple,
              expression: "showSimple"
            }
          ],
          staticClass: "cargo-advance-search-header"
        },
        [
          _c("div", { staticClass: "cargo-advance-search-toggle-trigger" }, [
            _c("i", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showAdv,
                  expression: "showAdv"
                }
              ],
              staticClass: "el-icon-arrow-left",
              style: {
                transform: !_vm.isShowingMoreSearchCondition
                  ? "rotate(-90deg)"
                  : "rotate(90deg)"
              },
              on: { click: _vm.upOrDownSearchCondition }
            })
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showSimple && !_vm.isShowingMoreSearchCondition,
                  expression: "showSimple && !isShowingMoreSearchCondition"
                }
              ],
              staticClass: "cargo-advance-search-quick"
            },
            [
              _vm.showPriceNo
                ? _c("el-input", {
                    ref: "keyword",
                    staticStyle: { width: "200px" },
                    attrs: {
                      no: "showPriceNo",
                      placeholder: _vm.simQueryPlaceholder,
                      spellcheck: false
                    },
                    on: { blur: _vm.keyWordBlur },
                    nativeOn: {
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        $event.preventDefault()
                        return _vm.toQuery($event)
                      }
                    },
                    model: {
                      value: _vm.filter.priceNo,
                      callback: function($$v) {
                        _vm.$set(_vm.filter, "priceNo", $$v)
                      },
                      expression: "filter.priceNo"
                    }
                  })
                : _vm._e(),
              !_vm.isShowingMoreSearchCondition && _vm.showPriceNo
                ? _c("cargo-advance-select", {
                    staticStyle: { width: "115px", display: "inline-block" },
                    attrs: {
                      no: "currency",
                      filterable: "",
                      disabled: _vm.disabled,
                      clearable: false,
                      "select-type": _vm.selectTypeNames.basic_data_Currency,
                      "default-value": _vm.filter.currency
                    },
                    on: { parentCallBack: _vm.changeCurrency }
                  })
                : _vm._e(),
              !_vm.isShowingMoreSearchCondition && !_vm.showPriceNo
                ? _c("cargo-advance-select", {
                    ref: "simPol",
                    staticStyle: {
                      width: "190px",
                      display: "inline-block",
                      "margin-left": "10px"
                    },
                    attrs: {
                      no: "simPol",
                      filterable: "",
                      placeholder: _vm.$t("Pricing.POLPrompt"),
                      "select-type": _vm.selectTypeNames.basic_data_Airport,
                      "custom-label": function(item) {
                        return "[" + item.code + "]" + item.englishName
                      },
                      "filter-tag-names": ["code", "englishName"],
                      "show-custom-label-in-option": true,
                      "default-value": _vm.filter.simPol
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.filter.simPol = p.value
                      }
                    }
                  })
                : _vm._e(),
              !_vm.isShowingMoreSearchCondition && !_vm.showPriceNo
                ? _c("cargo-advance-select", {
                    ref: "simPod",
                    staticStyle: {
                      width: "190px",
                      display: "inline-block",
                      "margin-left": "10px"
                    },
                    attrs: {
                      no: "simPod",
                      filterable: "",
                      placeholder: _vm.$t("Pricing.PODPrompt"),
                      "select-type": _vm.selectTypeNames.basic_data_Airport,
                      "custom-label": function(item) {
                        return "[" + item.code + "]" + item.englishName
                      },
                      "filter-tag-names": ["code", "englishName"],
                      "show-custom-label-in-option": true,
                      "default-value": _vm.filter.simPod
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.filter.simPod = p.value
                      }
                    }
                  })
                : _vm._e(),
              !_vm.isShowingMoreSearchCondition && _vm.showLevel
                ? _c(
                    "el-select",
                    {
                      staticStyle: {
                        width: "90px",
                        display: "inline-block",
                        "margin-left": "10px"
                      },
                      attrs: { no: "levelTiers" },
                      on: { change: _vm.onLevelChanged },
                      model: {
                        value: _vm.filter.level,
                        callback: function($$v) {
                          _vm.$set(_vm.filter, "level", $$v)
                        },
                        expression: "filter.level"
                      }
                    },
                    _vm._l(_vm.tiers, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                : _vm._e(),
              !_vm.isShowingMoreSearchCondition && !_vm.showPriceNo
                ? _c("cargo-advance-select", {
                    ref: "aircraft",
                    staticStyle: {
                      width: "190px",
                      display: "inline-block",
                      "margin-left": "10px"
                    },
                    attrs: {
                      no: "aircraft",
                      filterable: "",
                      placeholder: _vm.$t("Pricing.Aircraft"),
                      "select-type":
                        _vm.selectTypeNames.basic_data_AirplaneModel,
                      "filter-tag-names": ["model"],
                      "tag-name": "model",
                      "tag-value": "model",
                      "default-value": _vm.filter.aircraft
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.filter.aircraft = p.value
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            {
              ref: "searchOperations",
              staticClass: "cargo-advance-search-operations"
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: {
                    no: "toQuery",
                    type: "primary",
                    disabled: _vm.disabled
                  },
                  on: { click: _vm.toQuery }
                },
                [_vm._v(" " + _vm._s(_vm.$t("CargoMsg.Cargo_Query")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "resetSearch", type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.resetSearch()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Reset")))]
              ),
              _vm._t("operations")
            ],
            2
          )
        ]
      ),
      _vm._t("searchAreaHeader"),
      _vm.showAdv
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isShowingMoreSearchCondition,
                  expression: "isShowingMoreSearchCondition"
                }
              ],
              staticClass: "section cargo-advance-search-more"
            },
            [
              _c("div", {
                staticClass: "cargo-advance-search-more-operations"
              }),
              _c(
                "el-form",
                {
                  ref: "hbDetail",
                  attrs: {
                    "label-width": "80px",
                    "label-position": "left",
                    inline: true
                  }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { no: "rdoGroupOrg" },
                      model: {
                        value: _vm.rdoGroupOrg,
                        callback: function($$v) {
                          _vm.rdoGroupOrg = $$v
                        },
                        expression: "rdoGroupOrg"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { no: "pol", label: "pol" } }, [
                        _vm._v(_vm._s(_vm.$t("Pricing.POL")))
                      ]),
                      _c("el-radio", { attrs: { no: "pols", label: "pols" } }, [
                        _vm._v(_vm._s(_vm.$t("Pricing.POLs")))
                      ]),
                      _c("el-radio", { attrs: { no: "col", label: "col" } }, [
                        _vm._v(_vm._s(_vm.$t("Pricing.COL")))
                      ]),
                      _c("el-radio", { attrs: { no: "rol", label: "rol" } }, [
                        _vm._v(_vm._s(_vm.$t("Pricing.ROL")))
                      ]),
                      _c(
                        "el-radio",
                        { attrs: { no: "polCityCode", label: "polCityCode" } },
                        [_vm._v(_vm._s(_vm.$t("Pricing.POLCity")))]
                      )
                    ],
                    1
                  ),
                  _vm.rdoGroupOrg === "pols"
                    ? _c("cargo-pop-select-input", {
                        staticStyle: {
                          width: "190px",
                          display: "inline-block",
                          "margin-left": "10px"
                        },
                        attrs: {
                          no: "pols",
                          "column-defs": _vm.popSelectInputCols,
                          "select-type": _vm.selectTypeNames.basic_data_Airport,
                          "use-type": 3
                        },
                        model: {
                          value: _vm.filter.pols,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "pols", $$v)
                          },
                          expression: "filter.pols"
                        }
                      })
                    : _vm._e(),
                  _vm.rdoGroupOrg === "pol"
                    ? _c("cargo-advance-select", {
                        staticStyle: {
                          width: "190px",
                          display: "inline-block",
                          "margin-left": "10px"
                        },
                        attrs: {
                          no: "pol",
                          filterable: "",
                          placeholder: _vm.$t("Pricing.POLPrompt"),
                          "select-type": _vm.selectTypeNames.basic_data_Airport,
                          "custom-label": function(item) {
                            return "[" + item.code + "]" + item.englishName
                          },
                          "filter-tag-names": ["code", "englishName"],
                          "show-custom-label-in-option": true,
                          "callback-method-type": "obj",
                          "default-value": _vm.filter.pol
                        },
                        on: { parentCallBack: _vm.polChange }
                      })
                    : _vm._e(),
                  _vm.rdoGroupOrg === "col"
                    ? _c("cargo-advance-select", {
                        staticStyle: {
                          width: "190px",
                          display: "inline-block",
                          "margin-left": "10px"
                        },
                        attrs: {
                          no: "col",
                          filterable: "",
                          placeholder: _vm.$t("Pricing.COLPrompt"),
                          "select-type": _vm.selectTypeNames.basic_data_Country,
                          "default-value": _vm.filter.col
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.filter.col = p.value
                          }
                        }
                      })
                    : _vm._e(),
                  _vm.rdoGroupOrg === "rol"
                    ? _c("cargo-advance-select", {
                        staticStyle: {
                          width: "190px",
                          display: "inline-block",
                          "margin-left": "10px"
                        },
                        attrs: {
                          no: "rol",
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Region,
                          "default-value": _vm.filter.rol
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.filter.rol = p.value
                          }
                        }
                      })
                    : _vm._e(),
                  _vm.rdoGroupOrg === "polCityCode"
                    ? _c("cargo-advance-select", {
                        staticStyle: {
                          width: "190px",
                          display: "inline-block",
                          "margin-left": "10px"
                        },
                        attrs: {
                          no: "polCityCode",
                          "static-options": _vm.cityAirport,
                          "tag-name": "name",
                          "tag-value": "code",
                          placeholder: _vm.$t("Pricing.POLCityPrompt"),
                          clearable: "",
                          filterable: "",
                          "filter-tag-names": ["name", "code"],
                          "default-value": _vm.filter.polCityCode
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.filter.polCityCode = p.value
                          }
                        }
                      })
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { label: _vm.$t("Pricing.Carrier_Air") }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "242px" },
                        attrs: {
                          no: "carrier",
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": { airCmp: true },
                          "custom-label": function(item) {
                            return "[" + item.shortName + "]" + item.chineseName
                          },
                          "show-custom-label-in-option": true,
                          "default-value": _vm.filter.carrier
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.filter.carrier = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm.isManageModule || _vm.isShowCreatedBy
                    ? _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { label: _vm.$t("Pricing.CreatedBy") }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: {
                              width: "190px",
                              display: "inline-block",
                              "margin-left": "10px"
                            },
                            attrs: {
                              no: "createdBy",
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_User,
                              "default-value": _vm.filter.createdBy,
                              "callback-params": { key: "userId" }
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.filter.createdBy = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showCurrency
                    ? _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { label: _vm.$t("Pricing.Currency") }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "115px" },
                            attrs: {
                              no: "currency",
                              filterable: "",
                              disabled: _vm.disabled,
                              clearable: false,
                              "default-value": _vm.filter.currency,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Currency
                            },
                            on: { parentCallBack: _vm.changeCurrency }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Pricing.CreatedDate") } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "130px", "margin-left": "10px" },
                        attrs: {
                          no: "createDateFrom",
                          type: "date",
                          "picker-options": {
                            disabledDate: function(time) {
                              return (
                                time.getTime() >
                                new Date(
                                  _vm.filter.createDateTo + " 23:59:59"
                                ).getTime()
                              )
                            }
                          },
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.filter.createDateFrom,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "createDateFrom", $$v)
                          },
                          expression: "filter.createDateFrom"
                        }
                      }),
                      _c("span", { staticStyle: { margin: "5px" } }, [
                        _vm._v(_vm._s(_vm.$t("Pricing.EndDate")))
                      ]),
                      _c("el-date-picker", {
                        staticStyle: { width: "130px", "margin-left": "10px" },
                        attrs: {
                          no: "createDateTo",
                          "picker-options": {
                            disabledDate: function(time) {
                              return (
                                time.getTime() <
                                new Date(
                                  _vm.filter.createDateFrom + " 00:00:00"
                                ).getTime()
                              )
                            }
                          },
                          type: "date",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.filter.createDateTo,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "createDateTo", $$v)
                          },
                          expression: "filter.createDateTo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form",
                {
                  ref: "hbDetail2",
                  attrs: {
                    "label-width": "80px",
                    "label-position": "left",
                    inline: true
                  }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { no: "rdoGroupDes" },
                      model: {
                        value: _vm.rdoGroupDes,
                        callback: function($$v) {
                          _vm.rdoGroupDes = $$v
                        },
                        expression: "rdoGroupDes"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { no: "pod", label: "pod" } }, [
                        _vm._v(_vm._s(_vm.$t("Pricing.POD")))
                      ]),
                      _c("el-radio", { attrs: { no: "pods", label: "pods" } }, [
                        _vm._v(_vm._s(_vm.$t("Pricing.PODs")))
                      ]),
                      _c("el-radio", { attrs: { no: "cod", label: "cod" } }, [
                        _vm._v(_vm._s(_vm.$t("Pricing.COD")))
                      ]),
                      _c("el-radio", { attrs: { no: "rod", label: "rod" } }, [
                        _vm._v(_vm._s(_vm.$t("Pricing.ROD")))
                      ]),
                      _c(
                        "el-radio",
                        { attrs: { no: "podCityCode", label: "podCityCode" } },
                        [_vm._v(_vm._s(_vm.$t("Pricing.PODCity")))]
                      )
                    ],
                    1
                  ),
                  _vm.rdoGroupDes === "pod"
                    ? _c("cargo-advance-select", {
                        staticStyle: {
                          width: "190px",
                          display: "inline-block",
                          "margin-left": "10px"
                        },
                        attrs: {
                          no: "pod",
                          filterable: "",
                          placeholder: _vm.$t("Pricing.PODPrompt2"),
                          "select-type": _vm.selectTypeNames.basic_data_Airport,
                          "custom-label": function(item) {
                            return "[" + item.code + "]" + item.englishName
                          },
                          "filter-tag-names": ["code", "englishName"],
                          "show-custom-label-in-option": true,
                          "default-value": _vm.filter.pod,
                          "callback-method-type": "obj"
                        },
                        on: { parentCallBack: _vm.podChange }
                      })
                    : _vm._e(),
                  _vm.rdoGroupDes === "pods"
                    ? _c("cargo-pop-select-input", {
                        staticStyle: {
                          width: "190px",
                          display: "inline-block",
                          "margin-left": "10px"
                        },
                        attrs: {
                          no: "pods",
                          "column-defs": _vm.popSelectInputCols,
                          "select-type": _vm.selectTypeNames.basic_data_Airport,
                          "use-type": 3
                        },
                        model: {
                          value: _vm.filter.pods,
                          callback: function($$v) {
                            _vm.$set(_vm.filter, "pods", $$v)
                          },
                          expression: "filter.pods"
                        }
                      })
                    : _vm._e(),
                  _vm.rdoGroupDes === "cod"
                    ? _c("cargo-advance-select", {
                        staticStyle: {
                          width: "190px",
                          display: "inline-block",
                          "margin-left": "10px"
                        },
                        attrs: {
                          no: "cod",
                          filterable: "",
                          placeholder: _vm.$t("Pricing.CODAirPrompt"),
                          "select-type": _vm.selectTypeNames.basic_data_Country,
                          "default-value": _vm.filter.cod
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.filter.cod = p.value
                          }
                        }
                      })
                    : _vm._e(),
                  _vm.rdoGroupDes === "rod"
                    ? _c("cargo-advance-select", {
                        staticStyle: {
                          width: "190px",
                          display: "inline-block",
                          "margin-left": "10px"
                        },
                        attrs: {
                          no: "rod",
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Region,
                          "default-value": _vm.filter.rod
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.filter.rod = p.value
                          }
                        }
                      })
                    : _vm._e(),
                  _vm.rdoGroupDes === "podCityCode"
                    ? _c("cargo-advance-select", {
                        staticStyle: {
                          width: "190px",
                          display: "inline-block",
                          "margin-left": "10px"
                        },
                        attrs: {
                          no: "podCityCode",
                          "static-options": _vm.cityAirport,
                          "tag-name": "name",
                          "tag-value": "code",
                          placeholder: _vm.$t("Pricing.PODCityPrompt"),
                          clearable: "",
                          filterable: "",
                          "filter-tag-names": ["name", "code"],
                          "default-value": _vm.filter.podCityCode
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.filter.podCityCode = p.value
                          }
                        }
                      })
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { "margin-left": "10px" },
                      attrs: { label: _vm.$t("Pricing.BeginDate") }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "110px" },
                            attrs: {
                              no: "beginDate",
                              type: "date",
                              "picker-options": {
                                disabledDate: function(time) {
                                  return (
                                    time.getTime() >
                                    new Date(
                                      _vm.filter.endDate + " 23:59:59"
                                    ).getTime()
                                  )
                                }
                              },
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.filter.beginDate,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "beginDate", $$v)
                              },
                              expression: "filter.beginDate"
                            }
                          }),
                          _c("span", { staticStyle: { margin: "5px" } }, [
                            _vm._v(_vm._s(_vm.$t("Pricing.EndDate")))
                          ]),
                          _c("el-date-picker", {
                            staticStyle: { width: "110px" },
                            attrs: {
                              no: "endDate",
                              type: "date",
                              "picker-options": {
                                disabledDate: function(time) {
                                  return (
                                    time.getTime() <
                                    new Date(
                                      _vm.filter.beginDate + " 00:00:00"
                                    ).getTime()
                                  )
                                }
                              },
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.filter.endDate,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "endDate", $$v)
                              },
                              expression: "filter.endDate"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _vm.showLevel
                    ? _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { label: _vm.$t("Pricing.Level") }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: {
                                width: "190px",
                                display: "inline-block",
                                "margin-left": "10px"
                              },
                              attrs: { no: "level" },
                              on: { change: _vm.onLevelChanged },
                              model: {
                                value: _vm.filter.level,
                                callback: function($$v) {
                                  _vm.$set(_vm.filter, "level", $$v)
                                },
                                expression: "filter.level"
                              }
                            },
                            _vm._l(_vm.tiers, function(item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.showAllIn
                    ? _c(
                        "el-form-item",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { label: "All In" }
                        },
                        [
                          _c("el-checkbox", {
                            attrs: { no: "allIn" },
                            model: {
                              value: _vm.filter.allIn,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "allIn", $$v)
                              },
                              expression: "filter.allIn"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }